import './indicator-list.component.ajscss';

import { IHypervisionService } from '@hypervision/hypervision.service';
import { IChangesObject, IComponentController, IComponentOptions, isArray, isDefined, isUndefined } from 'angular';

import { DisplayDeprecatedComponent } from '@contact/upgrade';

import templateUrl from './indicator-list.component.ajs.html';

class IndicatorListCtrl extends DisplayDeprecatedComponent implements IComponentController {
  private selectedIndicator;
  private onChangeSelectedIndicator: Function;

  public indicators;
  public restUrl = '';

  constructor(private readonly hypervision: IHypervisionService) {
    super();
  }

  $onInit() {
    this.indicators = this.hypervision.getIndicators(true);
    if (isArray(this.indicators) && this.indicators.length > 0 && isUndefined(this.selectedIndicator)) {
      this.selectIndicator(this.indicators[0]);
    }
  }

  $onChanges(onChangesObj: { [property: string]: IChangesObject }) {
    if (onChangesObj['selectedIndicator'] && isDefined(onChangesObj['selectedIndicator'].currentValue)) {
      this.selectedIndicator = onChangesObj['selectedIndicator'].currentValue;
    }
  }

  cancelSwipe($event) {
    $event.stopPropagation();
  }

  selectIndicator(indicator) {
    this.onChangeSelectedIndicator({ $event: { selectedIndicator: indicator } });
  }
}

export class IndicatorList implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    selectedIndicator: '<',
    onChangeSelectedIndicator: '&',
  };
  controller = ['hypervision', IndicatorListCtrl];
}

export default 'indicatorList';
